/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Delete_RequestedInputs */

const en_issue_delete_requested = /** @type {(inputs: Issue_Delete_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the brand asked to delete this line: decide first`)
};

/**
* | output |
* | --- |
* | "the brand asked to delete this line: decide first" |
*
* @param {Issue_Delete_RequestedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_delete_requested = /** @type {((inputs?: Issue_Delete_RequestedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Delete_RequestedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_delete_requested(inputs)
});